import { AxiosInstance } from 'axios';

import { ITagGroup } from 'src/views/Admin/TagGroups/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';
import { cancellable } from '../../cancellable';

export default (api: AxiosInstance, url: string) => (id?: number) => {
  const urlWithId = id ? insertId(url, id) : url;
  return cancellable<ITagGroup[]>(
    (cancelOptions: any) => api.get(urlWithId, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/admin/tagGroups/get.ts